import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["activeCaptchaMessageId", "isValidating", "message", "recreateCount", "processedCaptchas", "targetCaptcha", "onClick", "className", "dispatch"];
import React from 'react';
import { connect } from 'react-redux';
import { CAPTCHA_MAX_RECREATE } from "../../../../shared/config";
import { FSMStages, LoadingStatus, useFSM } from "../../../../shared/model";
import { selectActiveCaptchaMessageId, selectCaptchaData, selectRecreateCount, selectRecreateProcess, selectValidateCaptchaStatus, useCaptchaContext } from "../../model";
import { RefreshButton } from "../../../../features/refresh-button/ui";
var ReloadButtonRender = function ReloadButtonRender(_ref) {
  var activeCaptchaMessageId = _ref.activeCaptchaMessageId,
    isValidating = _ref.isValidating,
    messageId = _ref.message.messageId,
    recreateCount = _ref.recreateCount,
    processedCaptchas = _ref.processedCaptchas,
    targetCaptcha = _ref.targetCaptcha,
    onClick = _ref.onClick,
    className = _ref.className,
    dispatch = _ref.dispatch,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var isProcessed = processedCaptchas.includes(messageId);
  var _useFSM = useFSM(),
    stage = _useFSM.stage;
  var _useCaptchaContext = useCaptchaContext(),
    captchaStage = _useCaptchaContext.captchaStage,
    captchaUpdate = _useCaptchaContext.captchaUpdate;
  var handleClick = function handleClick(e) {
    onClick === null || onClick === void 0 || onClick(e);
    void captchaUpdate((targetCaptcha === null || targetCaptcha === void 0 ? void 0 : targetCaptcha.captchaId) || messageId);
  };
  var isAfterBlockCaptcha = stage === FSMStages.CAPTCHA_NEEDED && captchaStage === 'blocked';
  if (isProcessed || recreateCount >= CAPTCHA_MAX_RECREATE || isValidating === LoadingStatus.loading || messageId !== activeCaptchaMessageId || !isAfterBlockCaptcha && !(captchaStage === 'retry' || captchaStage === 'start')) {
    return null;
  }
  return /*#__PURE__*/React.createElement(RefreshButton, _extends({
    buttonLabel: "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u043A\u0430\u043F\u0447\u0443 \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E",
    onClick: handleClick
  }, otherProps, {
    "data-t-id": "ui-ReloadButton"
  }));
};
var mapStateToProps = function mapStateToProps(store) {
  return {
    activeCaptchaMessageId: selectActiveCaptchaMessageId(store),
    isValidating: selectValidateCaptchaStatus(store),
    recreateCount: selectRecreateCount(store),
    processedCaptchas: selectRecreateProcess(store),
    targetCaptcha: selectCaptchaData(store)
  };
};
export var ReloadButton = connect(mapStateToProps)(ReloadButtonRender);